<template>
  <div class="contact-point-card">
    <div class="card__header card-padding-top card-padding-x">
      <div class="d-flex justify-content-between align-items-center">
        <span class="card__header--topic">Contact Point List</span>
        <!-- <atom-button
          v-if="isShowRequestFormButton && hasEditPermission"
          :isDisable="isDisableRequestFormButton"
          buttonId="request-form-button"
          buttonStyle="border"
          @click="onClickRequestForm"
        >
          <span class="button-text d-flex d-sm-none">Form</span>
          <span class="button-text d-none d-sm-flex">Create Form</span>
        </atom-button> -->
      </div>
      <div
        v-if="isShowInitialContactHeader"
        class="sale-contact-initial-header mt-2"
      >
        Contact Point <span class="text--danger">*</span>
      </div>
      <div
        v-for="(contact, index) in currentContactPointList"
        :key="index"
        class="contact-point-container"
      >
        <div class="contact-point-header my-1">
          Contact Point {{ Number(index) + 1 }}
        </div>
        <div class="d-block d-sm-flex contact-point-wrapper custom-max-width">
          <div class="icon-container d-flex">
            <div
              v-if="!isContractInDeletedStatus && hasEditPermission"
              class="icon-wrapper"
              @click="onClickEditContactDetail(contact, index)"
            >
              <feather-icon
                class="icon-size-20px"
                icon="EditIcon"
              ></feather-icon>
            </div>
            <div
              v-if="!isContractInDeletedStatus && hasEditPermission"
              class="ml-1 icon-wrapper"
              @click="onClickDeleteContactDetail(contact, index)"
            >
              <feather-icon
                class="icon-size-20px"
                icon="Trash2Icon"
              ></feather-icon>
            </div>
          </div>
          <div class="d-flex justify-content-center justify-content-sm-start">
            <div class="img-wrapper my-1 my-sm-0">
              <b-img
                v-if="contact.image"
                :src="contact.image"
                rounded
                class="profile-picture"
              />
              <div v-else class="no-image-container">
                <b-img v-bind="defaultPicture" rounded blank-color="#efefef" />
                <span class="no-image-text font-size-12">No image</span>
              </div>
            </div>
          </div>
          <div class="information-wrapper ml-0 ml-sm-2">
            <span class="d-block text-semibold-primary font-size-16">
              {{ contact.name.contactPointName }}
            </span>
            <div class="d-flex align-items-center custom-margin-top-6">
              <feather-icon icon="MailIcon" size="12" />
              <span class="font-size-12 pl-1"> {{ contact.email.email }} </span>
            </div>
            <div class="d-flex align-items-center custom-margin-top-6">
              <feather-icon icon="PhoneIcon" size="12" />
              <span class="font-size-12 pl-1"> {{ contact.phone.phone }} </span>
            </div>
            <span
              class="d-block mt-1 text-medium-grey font-size-12 text-uppercase"
            >
              Access Card
            </span>
            <ul
              v-if="contact.accessCardList && contact.accessCardList.length"
              class="list__ul"
            >
              <li
                v-for="(accessCard, index) in contact.accessCardList"
                :key="index"
                class="access-card"
              >
                <span class="font-size-12 font-weight-500">
                  {{
                    accessCard.siteName ? accessCard.siteName : "Site Not Found"
                  }}
                  -
                  {{ accessCard.locationName }}
                </span>
                <br />
                <span class="font-size-12">
                  [ Card No.
                  <span class="font-weight-500">
                    {{ accessCard.accessCardNumber }}
                  </span>
                  ]
                </span>
              </li>
            </ul>
            <span v-else class="font-size-12">
              This contact point has no access card.
            </span>
          </div>
        </div>
      </div>
      <div
        v-if="
          isShowSelectButton && !isContractInDeletedStatus && hasEditPermission
        "
        class="button-wrapper"
      >
        <div class="button-dash box-dashed" @click="onClickSelectContactPoint">
          <feather-icon
            class="icon-size-24px text-primary"
            icon="PlusCircleIcon"
          ></feather-icon>
          <label class="button--text">Select Contact Point</label>
        </div>
      </div>
      <div
        v-if="isErrorNotSelectContactPoint"
        class="mt-2 d-flex align-items-center"
      >
        <feather-icon
          class="icon-size-20px text-danger"
          icon="AlertCircleIcon"
        ></feather-icon>
        <span class="text-danger custom-error-message"
          >Please Select Contact Point</span
        >
      </div>
    </div>
    <!-- start modal section -->
    <!-- start modal request access form-->
    <molecule-modal-dialog
      modalId="modal-request-form"
      buttonTextLeft="Confirm"
      buttonColorLeft="primary"
      textTitle="Request Access Form"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmRequestFormButtonFromModal"
    >
      <template #body>
        <div class="select-location-container w-80 mt-1">
          <atom-select
            v-model="targetRequestForm.location"
            title="Location"
            placeholder="Select Location"
            label="locationName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtRequestFormLocation"
            :errorMessage="errorMessageAtSelector"
            :option="locationOption"
          ></atom-select>
        </div>
        <div class="select-name-container w-80 mt-1">
          <atom-select
            v-model="targetRequestForm.name"
            title="Full Name"
            placeholder="Select Customer"
            label="contactPointName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtRequestFormName"
            :errorMessage="errorMessageAtSelector"
            :option="contactPointOptionOnRequestForm"
          ></atom-select>
        </div>
        <div class="select-location-container w-80 mt-1">
          <atom-select
            v-model="targetRequestForm.form"
            title="Form"
            placeholder="Select Form"
            label="formName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtRequestFormForm"
            :errorMessage="errorMessageAtSelector"
            :option="formOption"
          ></atom-select>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal access form -->

    <!-- start modal delete -->
    <molecule-modal-dialog
      modalId="modal-confirm-delete-contact-point"
      icon="AlertCircleIcon"
      textTitle="Do you want to delete ?"
      buttonTextLeft="Delete"
      buttonColorLeft="danger"
      :isTextCenter="true"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmDeleteFromModal"
      @clickButtonRight="onClickCancelDeleteFromModal"
      @clickIconClose="onClickCancelDeleteFromModal"
    >
      <template #body>
        <div class="modal-confirm-delete-contact-point-body">
          <label class="text-center text--subtitle-modal">
            Contact Point: {{ targetContactPoint.name.contactPointName }}
            <br />
            will be deleted from this contract
          </label>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal delete -->

    <!-- start modal select-->
    <molecule-modal-dialog
      modalId="modal-select-contact-point"
      buttonTextLeft="Select"
      buttonColorLeft="primary"
      :textTitle="modalTitle"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmSelectFromModal"
      @clickButtonRight="onClickCancelSelectFromModal"
      @clickIconClose="onClickCancelSelectFromModal"
    >
      <template #body>
        <!-- Temporary Close this button util fix location option by site later -->
        <!-- <div
          v-if="hasCreateContactPointPermission"
          class="add-new-contact-button-container mt-2"
        >
          <atom-button
            buttonId="add-new-contact-button"
            buttonStyle="border"
            @click="onClickCreateNewContactFromModal"
          >
            <span class="button-text">Create New Contact</span>
          </atom-button>
        </div> -->
        <div class="select-name-container w-80 mt-1">
          <atom-select
            v-model="targetContactPoint.name"
            title="Full Name"
            placeholder="Select Customer"
            label="contactPointName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtSelectName"
            :errorMessage="errorMessageAtSelector"
            :option="contactPointOption"
          ></atom-select>
        </div>
        <div class="select-email-container w-80 mt-1">
          <atom-select
            v-model="targetContactPoint.email"
            title="Email"
            placeholder="Select Email"
            label="email"
            :isAsterisk="true"
            :isDisable="!targetContactPoint.name"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtSelectEmail"
            :errorMessage="errorMessageAtSelector"
            :option="emailOption"
          ></atom-select>
        </div>
        <div class="select-phone-container w-80 mt-1 mb-2">
          <atom-select
            v-model="targetContactPoint.phone"
            title="Phone Number"
            placeholder="Select Phone Number"
            label="phone"
            :isAsterisk="true"
            :isDisable="!targetContactPoint.name"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtSelectPhoneNumber"
            :errorMessage="errorMessageAtSelector"
            :option="phoneOption"
          ></atom-select>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal select -->

    <!-- start modal edit -->
    <molecule-modal-dialog
      modalId="modal-edit-contact-point"
      buttonTextLeft="Save Changes"
      buttonColorLeft="primary"
      :textTitle="modalTitle"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      :isDisableButtonLeft="!isTargetContactPointChange"
      @clickButtonLeft="onClickConfirmEditFromModal"
      @clickButtonRight="onClickCancelEditFromModal"
      @clickIconClose="onClickCancelEditFromModal"
    >
      <template #body>
        <!-- Temporary Close this button util fix location option by site later -->
        <!-- <div class="add-new-contact-button-container mt-2">
          <atom-button
            buttonId="add-new-contact-button"
            buttonStyle="border"
            @click="onClickCreateNewContactFromModal"
          >
            <span class="button-text">Create New Contact</span>
          </atom-button>
        </div> -->
        <div class="select-name-container w-80 mt-1">
          <atom-select
            v-model="targetContactPoint.name"
            title="Full Name"
            placeholder="Select Customer"
            label="contactPointName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtSelectName"
            :errorMessage="errorMessageAtSelector"
            :option="contactPointOption"
          ></atom-select>
        </div>
        <div class="select-email-container w-80 mt-1">
          <atom-select
            v-model="targetContactPoint.email"
            title="Email"
            placeholder="Select Email"
            label="email"
            :isAsterisk="true"
            :isDisable="!targetContactPoint.name"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtSelectEmail"
            :errorMessage="errorMessageAtSelector"
            :option="emailOption"
          ></atom-select>
        </div>
        <div class="select-phone-container w-80 mt-1 mb-2">
          <atom-select
            v-model="targetContactPoint.phone"
            title="Phone Number"
            placeholder="Select Phone Number"
            label="phone"
            :isAsterisk="true"
            :isDisable="!targetContactPoint.name"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtSelectPhoneNumber"
            :errorMessage="errorMessageAtSelector"
            :option="phoneOption"
          ></atom-select>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal edit -->

    <!-- start modal create new contact -->
    <molecule-modal-dialog
      modalId="modal-create-new-contact-point"
      buttonTextLeft="Create"
      buttonColorLeft="primary"
      textTitle="Create New Contact Point"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmCreateFromModal"
      @clickButtonRight="onClickCancelCreateFromModal"
      @clickIconClose="onClickCancelCreateFromModal"
    >
      <template #body>
        <div
          name="modal-create-new-contact-point"
          class="modal-content-container"
        >
          <div class="row mt-2">
            <div class="col-12 flex-row">
              <div class="profile-picture-container">
                <b-img
                  v-if="image"
                  :src="imageSrc"
                  rounded
                  class="profile-picture"
                />
                <div v-else class="no-image-container">
                  <b-img
                    v-bind="defaultPicture"
                    rounded
                    blank-color="#efefef"
                  />
                  <span class="no-image-text font-size-12">No image</span>
                </div>
              </div>
              <atom-file-input
                v-model="image"
                title="Select Profile Picture"
                class="mt-1 mb-1 mb-md-0"
              ></atom-file-input>
            </div>
            <div class="col-12 mt-2 mb-1 mb-md-0 flex-row align-self-end">
              <span class="text-topic--medium">Personal Data</span>
              <div class="row mt-1">
                <div class="col-12 col-md-6">
                  <atom-input
                    v-model="newContactPoint.firstName"
                    title="First Name"
                    placeholder="First Name"
                    :isAsterisk="true"
                    :isError="isErrorAtNewContactFirstName"
                    :errorMessage="errorMessageAtInput"
                  ></atom-input>
                </div>
                <div class="col-12 col-md-6 mt-1 mt-md-0">
                  <atom-input
                    v-model="newContactPoint.lastName"
                    title="Last Name"
                    placeholder="Last Name"
                    :isAsterisk="true"
                    :isError="isErrorAtNewContactLastName"
                    :errorMessage="errorMessageAtInput"
                  ></atom-input>
                </div>
              </div>
              <div class="row mt-1">
                <div class="col-12 col-md-6">
                  <atom-select
                    v-model="newContactPoint.idType"
                    title="Identification Type"
                    placeholder="Select Type"
                    label="name"
                    :isAsterisk="true"
                    :isClearable="false"
                    :isAppendToBody="false"
                    :isEnableProper="false"
                    :isError="isErrorAtNewContactIdType"
                    :errorMessage="errorMessageAtSelector"
                    :option="idTypeOption"
                  ></atom-select>
                </div>
                <div class="col-12 col-md-6 mt-1 mt-md-0">
                  <atom-input
                    v-model="newContactPoint.idOrPassportNumber"
                    title="ID/Passport Number"
                    placeholder="ID/Passport Number"
                    :isDisable="!newContactPoint.idType"
                    :isAsterisk="true"
                    :isError="isErrorAtNewContactContactIdOrPassportNumber"
                    :errorMessage="errorMessageAtInput"
                  ></atom-input>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-1 mt-md-3 mb-2">
            <div class="col-12 mb-1 mb-md-0 flex-row">
              <span class="text-topic--medium">Access List</span>
              <div v-if="newContactPoint.accesses.length">
                <div
                  v-for="(access, index) in newContactPoint.accesses"
                  :key="index"
                  class="access-container"
                >
                  <div class="access-header mt-2">
                    Access Card {{ index + 1 }}
                  </div>
                  <div class="access-detail">
                    <div class="d-flex justify-content-between">
                      <span class="location-name">{{
                        access.locationName
                      }}</span>
                      <div class="icon-container d-flex">
                        <div
                          class="icon-wrapper"
                          @click="onClickEditAccess(access, index)"
                        >
                          <feather-icon
                            class="icon-size-20px"
                            icon="EditIcon"
                          ></feather-icon>
                        </div>
                        <div
                          class="ml-1 icon-wrapper"
                          @click="onClickDeleteAccess(access, index)"
                        >
                          <feather-icon
                            class="icon-size-20px"
                            icon="Trash2Icon"
                          ></feather-icon>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between">
                      <span class="access-card-number"
                        >Access Card Number:
                        <b>{{ access.accessCardNumber }}</b></span
                      >
                    </div>
                    <hr />
                  </div>
                </div>
              </div>
              <div class="button-wrapper">
                <div
                  class="button-dash box-dashed"
                  @click="onClickAddNewAccess"
                >
                  <feather-icon
                    class="icon-size-24px text-primary"
                    icon="PlusCircleIcon"
                  ></feather-icon>
                  <label class="button--text">Add New Access</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-1 mt-md-3 mb-2">
            <div class="col-12 col-md-6 mb-1 mb-md-0 flex-row">
              <span class="text-topic--medium">Email List</span>
              <div class="mt-1">
                <atom-input
                  v-model="newContactPoint.email.primary.email"
                  title="Email 1"
                  placeholder="Email"
                  :isAsterisk="true"
                  :isError="isErrorAtNewContactEmailPrimary"
                  :errorMessage="errorMessageAtInput"
                ></atom-input>
              </div>
              <div class="mt-1">
                <atom-input
                  v-model="newContactPoint.email.secondary.email"
                  title="Email 2"
                  placeholder="Email"
                  :isError="isErrorAtNewContactEmailSecondary"
                  :errorMessage="errorMessageAtInput"
                ></atom-input>
              </div>
              <div class="mt-1">
                <atom-input
                  v-model="newContactPoint.email.third.email"
                  title="Email 3"
                  placeholder="Email"
                  :isError="isErrorAtNewContactEmailThird"
                  :errorMessage="errorMessageAtInput"
                ></atom-input>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-1 mt-md-0 flex-row">
              <span class="text-topic--medium">Phone Number List</span>
              <div class="mt-1">
                <atom-input
                  v-model="newContactPoint.phone.primary.phone"
                  title="Phone Number 1"
                  placeholder="Phone Number"
                  :isAsterisk="true"
                  :isError="isErrorAtNewContactPhoneNumberPrimary"
                  :errorMessage="errorMessageAtInput"
                ></atom-input>
              </div>
              <div class="mt-1">
                <atom-input
                  v-model="newContactPoint.phone.secondary.phone"
                  title="Phone Number 2"
                  placeholder="Phone Number"
                  :isError="isErrorAtNewContactPhoneNumberSecondary"
                  :errorMessage="errorMessageAtInput"
                ></atom-input>
              </div>
              <div class="mt-1">
                <atom-input
                  v-model="newContactPoint.phone.third.phone"
                  title="Phone Number 3"
                  placeholder="Phone Number"
                  :isError="isErrorAtNewContactPhoneNumberThird"
                  :errorMessage="errorMessageAtInput"
                ></atom-input>
              </div>
            </div>
          </div>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal create new contact -->

    <!-- start modal delete access-->
    <molecule-modal-dialog
      modalId="modal-confirm-delete-access"
      icon="AlertCircleIcon"
      textTitle="Do you want to delete ?"
      buttonTextLeft="Delete"
      buttonColorLeft="danger"
      :isTextCenter="true"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmDeleteAccessFromModal"
    >
      <template #body>
        <div class="modal-confirm-delete-access-body">
          <label class="text-center text--subtitle-modal">
            Access ID: {{ targetAccess.accessCardNumber }} At
            {{ targetAccess.locationName }}<br />
            will be deleted from this contact point/sale.
          </label>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal delete access -->

    <!-- start modal add new access -->
    <molecule-modal-dialog
      modalId="modal-add-access"
      buttonTextLeft="Add"
      buttonColorLeft="primary"
      textTitle="Add New Access"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmAddNewAccessFromModal"
      @clickButtonRight="onClickCancelAddNewAccessFromModal"
      @clickIconClose="onClickCancelAddNewAccessFromModal"
    >
      <template #body>
        <div class="select-location-container w-80 mt-1">
          <atom-select
            v-model="newAccess.location"
            title="Location"
            placeholder="Select Location"
            label="locationName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtNewSelectLocation"
            :errorMessage="errorMessageAtSelector"
            :option="locationOption"
          ></atom-select>
        </div>
        <div class="access-card-number-container w-80 mt-1">
          <atom-input
            v-model="newAccess.accessCardNumber"
            title="Access Card Number"
            placeholder="Access Card Number"
            :isAsterisk="true"
            :isError="isErrorAtNewAccessCardNumber"
            :errorMessage="errorMessageAtInput"
          ></atom-input>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal add new access -->

    <!-- start modal edit access -->
    <molecule-modal-dialog
      modalId="modal-edit-access"
      buttonTextLeft="Save Changes"
      buttonColorLeft="primary"
      textTitle="Edit Access"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmEditAccessFromModal"
      @clickButtonRight="onClickCancelEditAccessFromModal"
      @clickIconClose="onClickCancelEditAccessFromModal"
    >
      <template #body>
        <div class="select-location-container w-80 mt-1">
          <atom-select
            v-model="targetAccess.location"
            title="Location"
            placeholder="Select Location"
            label="locationName"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtEditSelectLocation"
            :errorMessage="errorMessageAtSelector"
            :option="locationOption"
          ></atom-select>
        </div>
        <div class="access-card-number-container w-80 mt-1">
          <atom-input
            v-model="targetAccess.accessCardNumber"
            title="Access Card Number"
            placeholder="Access Card Number"
            :isAsterisk="true"
            :isError="isErrorAtEditAccessCardNumber"
            :errorMessage="errorMessageAtInput"
          ></atom-input>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal edit access -->

    <!-- end modal section -->
  </div>
</template>

<script>
const base64Encode = (data) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(data)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

import { BImg } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomFileInput from "@/components/atoms/AtomFileInput.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import mixinsValidators from "@/mixins/mixinsValidator"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"
import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"

export default {
  name: "MoleculeContactPoint",
  components: {
    AtomButton,
    AtomFileInput,
    AtomInput,
    AtomSelect,
    BImg,
    MoleculeModalDialog,
  },
  props: {
    contractStatus: {
      type: String,
      required: false,
      default: null,
    },
    basedContactPointList: {
      type: Array,
      required: false,
      default: () => [],
    },
    contactPointOption: {
      type: Array,
      required: true,
    },
    locationOption: {
      type: Array,
      required: false,
      default: () => [],
    },
    formOption: {
      type: Array,
      required: false,
      default: () => [],
    },
    selectedContactPointId: {
      type: String,
      required: false,
      default: null,
    },
    selectedContactPointDetail: {
      type: Object,
      required: false,
      default: null,
    },
    isValidateTrigger: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasEditPermission: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Array,
      required: false,
      default: null,
    },
  },
  mixins: [mixinsValidators, mixinsObjectHelper, mixinsUser],
  emits: [
    "onUpdateContactPoint",
    "onUpdateErrorInMoleculeContactPoint",
    "onSelectContactPoint",
    "onRequestForm",
  ],
  data() {
    return {
      modalId: null,
      modalAccessCardId: null,
      previousSelectContactPointModalId: null,
      defaultPicture: { blank: true, width: 150, height: 150 },
      image: null,
      imageSrc: null,
      isValidateSelectContactTrigger: false,
      isValidateNewContactTrigger: false,
      isValidateRequestFormTrigger: false,
      isValidateNewAccessInModalTrigger: false,
      isValidateEditAccessInModalTrigger: false,
      errorMessageAtInput: "Please enter valid data",
      errorMessageAtSelector: "Please select data",
      modalTitle: "",
      emailOption: [],
      phoneOption: [],
      currentContactPointList: [],
      contactPointOptionOnRequestForm: [],
      idTypeOption: ["ID", "Passport Number"],
      newContactPoint: {
        profilePicture: null,
        firstName: "",
        lastName: "",
        idType: "",
        idOrPassportNumber: "",
        email: {
          primary: { contactPointEmailId: null, email: "" },
          secondary: { contactPointEmailId: null, email: "" },
          third: { contactPointEmailId: null, email: "" },
        },
        phone: {
          primary: { contactPointPhoneId: null, phone: "" },
          secondary: { contactPointPhoneId: null, phone: "" },
          third: { contactPointPhoneId: null, phone: "" },
        },
        accesses: [],
      },
      targetContactPoint: {
        name: "",
        email: "",
        phone: "",
      },
      originTargetContactPoint: null,
      targetRequestForm: {
        name: null,
        location: null,
      },
      targetAccess: {
        locationId: "",
        locationName: "",
        accessCardNumber: "",
      },
      newAccess: {
        location: null,
        accessCardNumber: "",
      },
      currentContactPointImage: "",
      currentContractPointAccess: [],
    }
  },
  computed: {
    contractId() {
      return this.$route?.params?.id
    },
    hasCreateContactPointPermission() {
      return this.hasPermission(PermissionUser.WPM.NTDC_CONTACT_POINT_WRITE)
    },
    isShowInitialContactHeader() {
      return this.currentContactPointList.length === 0
    },
    isShowRequestFormButton() {
      return (
        this.hasString(this.contractId) &&
        this.contractStatus?.toLowerCase() === "approved"
      )
    },
    isShowSelectButton() {
      return this.currentContactPointList.length < 10
    },
    isDisableRequestFormButton() {
      return this.contractStatus?.toLowerCase() !== "approved"
    },
    isContractInDeletedStatus() {
      return this.contractStatus?.toLowerCase() === "deleted"
    },
    isDefaultTargetValue() {
      return this.isEmptyObject(this.targetContactPoint.name)
    },
    isModalSelectContactPointOpen() {
      return (
        this.modalId === "modal-select-contact-point" ||
        this.modalId === "modal-edit-contact-point"
      )
    },
    isErrorAtSelectName() {
      return this.isValidateSelectContactTrigger
        ? this.isEmptyObject(this.targetContactPoint.name)
        : false
    },
    isErrorAtSelectEmail() {
      return this.isValidateSelectContactTrigger
        ? this.isEmptyObject(this.targetContactPoint.email)
        : false
    },
    isErrorAtSelectPhoneNumber() {
      return this.isValidateSelectContactTrigger
        ? this.isEmptyObject(this.targetContactPoint.phone)
        : false
    },
    isErrorAtNewContactFirstName() {
      return this.isValidateNewContactTrigger
        ? this.isEmptyString(this.newContactPoint.firstName)
        : false
    },
    isErrorAtNewContactLastName() {
      return this.isValidateNewContactTrigger
        ? this.isEmptyString(this.newContactPoint.lastName)
        : false
    },
    isErrorAtNewContactIdType() {
      return this.isValidateNewContactTrigger
        ? this.isEmptyString(this.newContactPoint.idType)
        : false
    },
    isErrorAtNewContactContactIdOrPassportNumber() {
      return this.isValidateNewContactTrigger
        ? this.isEmptyString(this.newContactPoint.idOrPassportNumber)
        : false
    },
    isErrorAtNewContactEmailPrimary() {
      return this.isValidateNewContactTrigger
        ? this.isEmptyObject(this.newContactPoint.email.primary.email) ||
            this.isInvalidEmail(this.newContactPoint.email.primary.email)
        : false
    },
    isErrorAtNewContactEmailSecondary() {
      return this.isValidateNewContactTrigger
        ? this.isInvalidEmail(this.newContactPoint.email.secondary.email) &&
            !this.isEmptyString(this.newContactPoint.email.secondary.email)
        : false
    },
    isErrorAtNewContactEmailThird() {
      return this.isValidateNewContactTrigger
        ? this.isInvalidEmail(this.newContactPoint.email.third.email) &&
            !this.isEmptyString(this.newContactPoint.email.third.email)
        : false
    },
    isErrorAtNewContactPhoneNumberPrimary() {
      return this.isValidateNewContactTrigger
        ? this.isEmptyString(this.newContactPoint.phone.primary.phone)
        : // ||this.isInvalidPhoneNumber(this.newContactPoint.phone.primary.phone)
          false
    },
    isErrorAtNewContactPhoneNumberSecondary() {
      return false
      // if (this.newContactPoint.phone.secondary) {
      //   return this.isValidateNewContactTrigger
      //     ? this.isInvalidPhoneNumber(
      //         this.newContactPoint.phone.secondary.phone
      //       ) && !this.isEmptyString(this.newContactPoint.phone.secondary.phone)
      //     : false
      // } else {
      //   return false
      // }
    },
    isErrorAtNewContactPhoneNumberThird() {
      return false
      // if (this.newContactPoint.phone.third.phone) {
      //   return this.isValidateNewContactTrigger
      //     ? this.isInvalidPhoneNumber(this.newContactPoint.phone.third.phone) &&
      //         !this.isEmptyString(this.newContactPoint.phone.third.phone)
      //     : false
      // } else {
      //   return false
      // }
    },
    isErrorAtRequestFormForm() {
      return this.isValidateRequestFormTrigger
        ? this.isEmptyObject(this.targetRequestForm.form)
        : false
    },
    isErrorAtRequestFormLocation() {
      return this.isValidateRequestFormTrigger
        ? this.isEmptyObject(this.targetRequestForm.location)
        : false
    },
    isErrorAtRequestFormName() {
      return this.isValidateRequestFormTrigger
        ? this.isEmptyObject(this.targetRequestForm.name)
        : false
    },
    isErrorOccurAtSelectContactPoint() {
      return (
        this.isErrorAtSelectName ||
        this.isErrorAtSelectEmail ||
        this.isErrorAtSelectPhoneNumber
      )
    },
    isErrorOccurAtCreateNewContactPoint() {
      return (
        this.isErrorAtNewContactFirstName ||
        this.isErrorAtNewContactLastName ||
        this.isErrorAtNewContactIdType ||
        this.isErrorAtNewContactContactIdOrPassportNumber ||
        this.isErrorAtNewContactEmailPrimary ||
        this.isErrorAtNewContactEmailSecondary ||
        this.isErrorAtNewContactEmailThird ||
        this.isErrorAtNewContactPhoneNumberPrimary ||
        this.isErrorAtNewContactPhoneNumberSecondary ||
        this.isErrorAtNewContactPhoneNumberThird
      )
    },
    isErrorOccurAtRequestForm() {
      return (
        this.isErrorAtRequestFormForm ||
        this.isErrorAtRequestFormName ||
        this.isErrorAtRequestFormLocation
      )
    },
    isTargetContactPointChange() {
      return this.compareIsChangeObject(
        this.originTargetContactPoint,
        this.targetContactPoint
      )
    },
    // access computed section start
    isErrorAtEditSelectLocation() {
      return this.isValidateEditAccessInModalTrigger
        ? this.isEmptyString(this.targetAccess.locationName)
        : false
    },
    isErrorAtEditAccessCardNumber() {
      return this.isValidateEditAccessInModalTrigger
        ? this.isEmptyString(this.targetAccess.accessCardNumber)
        : false
    },
    isErrorOccurAtEditSelectAccessCard() {
      return (
        this.isErrorAtEditSelectLocation || this.isErrorAtEditAccessCardNumber
      )
    },
    isErrorAtNewSelectLocation() {
      return this.isValidateNewAccessInModalTrigger
        ? this.isEmptyObject(this.newAccess.location)
        : false
    },
    isErrorAtNewAccessCardNumber() {
      return this.isValidateNewAccessInModalTrigger
        ? this.isEmptyString(this.newAccess.accessCardNumber)
        : false
    },
    isErrorOccurAtNewSelectAccessCard() {
      return (
        this.isErrorAtNewSelectLocation || this.isErrorAtNewAccessCardNumber
      )
    },
    isErrorNotSelectContactPoint() {
      return this.isValidateTrigger
        ? this.currentContactPointList.length === 0
        : false
    },
    // access computed section end
  },
  watch: {
    image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then((value) => {
              this.imageSrc = value
              this.$emit("onUpdateContactPointProfilePicture", this.image)
            })
            .catch(() => {
              this.imageSrc = null
            })
        } else {
          this.imageSrc = null
        }
      }
    },
    basedContactPointList: {
      deep: true,
      handler() {
        if (this.basedContactPointList) {
          this.currentContactPointList = this.getDecoratedBaseContactData(
            this.basedContactPointList
          )
        }
      },
    },
    currentContactPointList: {
      deep: true,
      handler() {
        if (this.currentContactPointList) {
          this.contactPointOptionOnRequestForm =
            this.currentContactPointList.map(
              (contactPoint) => contactPoint.name
            )
        }
      },
    },
    contactPointOption: {
      deep: true,
      handler() {
        if (this.selectedContactPointId) {
          this.targetContactPoint.name = this.contactPointOption.find(
            (contactPoint) =>
              contactPoint.contactPointId === this.selectedContactPointId
          )
        }
      },
    },
    selectedContactPointDetail: {
      deep: true,
      handler() {
        if (this.selectedContactPointDetail) {
          this.currentContactPointImage = this.selectedContactPointDetail.image
          this.currentContractPointAccess =
            this.selectedContactPointDetail.accesses
          this.emailOption = this.selectedContactPointDetail.emails
          this.phoneOption = this.selectedContactPointDetail.phones
        }
        if (this.selectedContactPointId) {
          this.targetContactPoint.email = this.emailOption[0]
          this.targetContactPoint.phone = this.phoneOption[0]
          this.$emit("onClearSelectedContactPointId")
        }
      },
    },
    "targetContactPoint.name": {
      deep: true,
      handler(newValue, oldValue) {
        if (this.targetContactPoint.name) {
          const selectedContactPoint = { ...this.targetContactPoint.name }
          this.$emit("onSelectContactPoint", selectedContactPoint)
        }
        if (oldValue && this.isModalSelectContactPointOpen) {
          this.targetContactPoint.email = null
          this.targetContactPoint.phone = null
        }
      },
    },
    isErrorNotSelectContactPoint: {
      deep: true,
      immediate: true,
      handler() {
        this.$emit(
          "onUpdateErrorAtMoleculeContactPoint",
          this.isErrorNotSelectContactPoint
        )
      },
    },
  },
  methods: {
    getDecoratedBaseContactData(basedContactPointList) {
      return basedContactPointList.map((item) => {
        return {
          name: {
            contactPointName:
              item.contactFirstname + " " + item.contactLastname,
            contactPointId: item.contactId,
          },
          image: item.contactImage,
          email: {
            email: item.contactEmail,
            contactPointEmailId: item.contactEmailId,
          },
          phone: {
            phone: item.contactPhone,
            contactPointPhoneId: item.contactPhoneId,
          },
          accessCardList: item.contactAccesses.map((access) => {
            return {
              locationName: access.locationName,
              accessCardNumber: access.accessCardNumber,
              siteName: access.siteName,
            }
          }),
        }
      })
    },
    setDefaultTargetValue() {
      this.targetContactPoint = {
        name: "",
        email: "",
        phone: "",
      }
    },
    setDefaultFormValue() {
      this.targetRequestForm = {
        form: null,
        name: null,
        location: null,
      }
    },
    setDefaultNewContactPoint() {
      this.newContactPoint = {
        profilePicture: null,
        firstName: "",
        lastName: "",
        idType: "",
        idOrPassportNumber: "",
        email: {
          primary: "",
          secondary: "",
          third: "",
        },
        phone: {
          primary: "",
          secondary: "",
          third: "",
        },
        accesses: [],
      }
    },
    editContactPoint() {
      const targetIndex = this.targetContactPoint.index
      const editedContactPointValue = {
        name: this.targetContactPoint.name,
        email: this.targetContactPoint.email,
        phone: this.targetContactPoint.phone,
        image: this.currentContactPointImage,
        accessCardList: this.currentContractPointAccess,
      }
      this.$set(
        this.currentContactPointList,
        targetIndex,
        editedContactPointValue
      )
      this.closeModal()
      this.$emit(
        "onUpdateCurrentContactPointList",
        this.currentContactPointList
      )
    },
    deleteContactPoint() {
      const targetIndex = this.targetContactPoint.index
      this.currentContactPointList.splice(targetIndex, 1)
      this.$emit(
        "onUpdateCurrentContactPointList",
        this.currentContactPointList
      )
    },
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },
    onClickSelectContactPoint() {
      this.setDefaultTargetValue()
      this.modalTitle = "Select Contact Point"
      this.modalId = "modal-select-contact-point"
      this.$bvModal.show(this.modalId)
    },
    onClickEditContactDetail(contactPoint, index) {
      this.modalTitle = "Edit Contact Point"
      this.targetContactPoint = { ...contactPoint, index: index }
      this.originTargetContactPoint = JSON.parse(
        JSON.stringify(this.targetContactPoint)
      )
      this.modalId = "modal-edit-contact-point"
      this.$bvModal.show(this.modalId)
    },

    onClickDeleteContactDetail(contactPoint, index) {
      this.targetContactPoint = { ...contactPoint, index: index }
      this.modalId = "modal-confirm-delete-contact-point"
      this.$bvModal.show(this.modalId)
    },
    onClickConfirmDeleteFromModal() {
      this.deleteContactPoint()
      this.setDefaultTargetValue()
      this.closeModal()
    },
    onClickCancelDeleteFromModal() {
      this.setDefaultTargetValue()
    },
    onClickCreateNewContactFromModal() {
      this.previousSelectContactPointModalId = this.modalId
      this.closeModal()
      this.modalId = "modal-create-new-contact-point"
      this.$bvModal.show(this.modalId)
    },
    onClickConfirmCreateFromModal() {
      this.isValidateNewContactTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccurAtCreateNewContactPoint) {
          const newContactPointDetail = { ...this.newContactPoint }
          this.$emit("onRequestCreateNewContactPoint", newContactPointDetail)
          this.isValidateNewContactTrigger = false
          this.setDefaultNewContactPoint()
          this.closeModal()
          this.modalId = this.previousSelectContactPointModalId
          this.$bvModal.show(this.modalId)
        }
      })
    },
    onClickCancelCreateFromModal() {
      this.modalId = this.previousSelectContactPointModalId
      this.$bvModal.show(this.modalId)
      this.setDefaultNewContactPoint()
    },
    onClickConfirmSelectFromModal() {
      this.isValidateSelectContactTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccurAtSelectContactPoint) {
          this.currentContactPointList.push({
            ...this.targetContactPoint,
            image: this.currentContactPointImage,
            accessCardList: this.currentContractPointAccess,
          })
          this.$emit(
            "onUpdateCurrentContactPointList",
            this.currentContactPointList
          )
          this.closeModal()
          this.isValidateSelectContactTrigger = false
          this.setDefaultTargetValue()
        }
      })
    },
    onClickCancelSelectFromModal() {
      this.setDefaultTargetValue()
    },
    onClickConfirmEditFromModal() {
      this.isValidateSelectContactTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccurAtSelectContactPoint) {
          this.editContactPoint()
          this.isValidateSelectContactTrigger = false
        }
      })
    },
    onClickCancelEditFromModal() {
      this.setDefaultTargetValue()
    },
    onClickRequestForm() {
      this.modalId = "modal-request-form"
      this.$bvModal.show(this.modalId)
    },
    onClickConfirmRequestFormButtonFromModal() {
      this.isValidateRequestFormTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccurAtRequestForm) {
          const contractId = this.contractId.replace(/\D/g, "")
          const formId = this.targetRequestForm.form.formId
          const requestFormData = {
            locationId: this.targetRequestForm.location.locationId,
            floorName: this.targetRequestForm.location.locationId, // To be remove later
            formName: this.targetRequestForm.form.formName,
            contactPointId: this.targetRequestForm.name.contactPointId,
          }
          this.closeModal()
          this.$emit("onRequestForm", contractId, formId, requestFormData)
          this.setDefaultFormValue()
          this.isValidateRequestFormTrigger = false
        }
      })
    },

    // access method section start
    setDefaultTargetAccessValue() {
      this.targetAccess = {
        locationId: "",
        locationName: "",
        accessCardNumber: "",
      }
    },
    setDefaultNewAccess() {
      this.newAccess = {
        location: null,
        accessCardNumber: "",
      }
    },
    closeAccessModal() {
      this.$bvModal.hide(this.modalAccessCardId)
    },
    editAccess() {
      const targetIndex = this.targetAccess.index
      const newAccessValue = {
        locationId: this.targetAccess.location.locationId,
        locationName: this.targetAccess.location.locationName,
        accessCardNumber: this.targetAccess.accessCardNumber,
      }
      this.$set(this.newContactPoint.accesses, targetIndex, newAccessValue)
    },
    deleteAccess() {
      const targetIndex = this.targetAccess.index
      this.newContactPoint.accesses.splice(targetIndex, 1)
    },
    onClickAddNewAccess() {
      this.setDefaultTargetAccessValue()
      this.modalAccessCardId = "modal-add-access"
      this.$bvModal.show(this.modalAccessCardId)
    },

    onClickEditAccess(access, index) {
      this.targetAccess = {
        ...access,
        index: index,
      }
      this.targetAccess.location = this.locationOption.find(
        (location) => location.locationName === this.targetAccess.locationName
      )
      this.modalAccessCardId = "modal-edit-access"
      this.$bvModal.show(this.modalAccessCardId)
    },
    onClickDeleteAccess(access, index) {
      this.targetAccess = {
        ...access,
        index: index,
      }
      this.modalAccessCardId = "modal-confirm-delete-access"
      this.$bvModal.show(this.modalAccessCardId)
    },
    onClickConfirmDeleteAccessFromModal() {
      this.deleteAccess()
      this.setDefaultTargetAccessValue()
      this.closeAccessModal()
    },
    onClickConfirmAddNewAccessFromModal() {
      this.isValidateNewAccessInModalTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccurAtNewSelectAccessCard) {
          const newAccessData = {
            locationId: this.newAccess.location.locationId,
            locationName: this.newAccess.location.locationName,
            accessCardNumber: this.newAccess.accessCardNumber,
          }
          this.newContactPoint.accesses.push(newAccessData)
          this.setDefaultNewAccess()
          this.closeAccessModal()
          this.isValidateNewAccessInModalTrigger = false
        }
      })
    },
    onClickCancelAddNewAccessFromModal() {
      this.setDefaultNewAccess()
    },
    onClickConfirmEditAccessFromModal() {
      this.isValidateEditAccessInModalTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccurAtEditSelectAccessCard) {
          this.editAccess()
          this.closeAccessModal()
          this.setDefaultTargetAccessValue()
          this.isValidateEditAccessInModalTrigger = false
        }
      })
    },
    onClickCancelEditAccessFromModal() {
      this.setDefaultTargetAccessValue()
    },
    // access method section end
  },
}
</script>

<style lang="scss" scoped>
.card__header {
  padding: 21px;
  margin-bottom: 14px;
}

.card__header--topic {
  font-weight: 500;
  font-size: 18px;
}

.button-dash {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-wrapper,
.contact-point-detail {
  width: 100%;
}

.button--text {
  margin-left: 10px;
  margin-bottom: 0;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.box-dashed {
  height: 60px;
  border: 1px dashed rgba(115, 103, 240, 0.4);
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  &:hover {
    background-color: #f9f9fe;
  }
}

.text--danger {
  color: #ea5455;
}

.text-topic--medium {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #5e5873;
}

.text--subtitle-modal {
  font-size: 14px;
}

.custom-error-message {
  margin-left: 8px;
  line-height: 1.5;
  font-size: 12px;
}

.sale-contact-initial-header {
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
}

.contact-point-header {
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  color: #b9b9c3;
}

.contact-point-detail {
  margin-top: 9px;
}

.contact-point-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #82868b;
}

.contact-email-and-phone {
  margin-top: 9px;
  margin-bottom: 5px;
  width: 100%;
}

.icon-wrapper:hover {
  cursor: pointer;
}

.add-new-contact-button-container {
  display: flex;
  align-self: flex-end;
  padding-right: 2rem;
}

div[name="modal-create-new-contact-point"].modal-content-container {
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

.profile-picture-container {
  display: flex;
  justify-content: center;
  height: 150px;
}

.profile-picture {
  width: 150px;
  height: 150px;
}

.button--text {
  margin-left: 10px;
  margin-bottom: 0;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.box-dashed {
  height: 60px;
  border: 1px dashed rgba(115, 103, 240, 0.4);
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  &:hover {
    background-color: #f9f9fe;
  }
}

.access-header {
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  color: #b9b9c3;
}

.access-detail {
  margin-top: 9px;
}

.location-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #82868b;
}

.icon-wrapper:hover {
  cursor: pointer;
}

.custom-margin-top-6 {
  margin-top: 6px;
}

.list__ul {
  padding-left: 16px;
}

li:not(:last-child) {
  margin-bottom: 4px;
}

.contact-point-wrapper {
  position: relative;
  padding-bottom: 16px;
  border-bottom: 1px solid #ebe9f1;
}

.icon-container {
  position: absolute;
  right: 0;
  top: -36px;
}

.custom-max-width {
  max-width: 550px;
}

.img-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 150px;
  border-radius: 0.357rem;
  background-color: #efefef;
}

.no-image-container {
  position: relative;
  .no-image-text {
    z-index: 2;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.access-detail,
.button-wrapper {
  max-width: 550px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .icon-container {
    position: absolute;
    right: 0;
    top: 0;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .button-wrapper,
  .contact-point-detail {
    width: 550px;
  }
  .contact-email-and-phone {
    width: 80%;
  }
  .add-new-contact-button-container {
    padding-right: 3.25rem;
  }
  div[name="modal-create-new-contact-point"].modal-content-container {
    height: 600px;
  }
  .access-detail,
  .button-wrapper {
    width: 550px;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}
</style>
